import { NgModule, Provider, inject } from '@angular/core';
import { FMNTS_FORMS_OPTIONS } from '@fmnts/common/forms';
import {
  DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN,
  DECLARATIVE_FORMS_VALIDATOR_TOKEN,
  DeclarativeFormsModule as FmntsDeclarativeFormsModule,
} from '@fmnts/declarative-forms';
import { DeclarativeFormsCommonModule } from '@fmnts/declarative-forms/common';
import { provideDeclarativeFormsGeolocationFeature } from '@fmnts/declarative-forms/geolocation';

// ==================================================================
// Module components and directives
// ==================================================================

import { NextFormComponent } from './components/declarative-form/next-form.component';
import { FormActionsComponent } from './components/form-actions/form-actions.component';

// ==================================================================
// Services to inject for `Validator` on next forms
// ==================================================================
import { DateValidationBuilder } from './validation/date-validation-builder.service';
import { PaymentValidationService } from './validation/payment-validation-builder.service';
import { PhoneValidationBuilder } from './validation/phone-validation-builder.service';

// ==================================================================
// Services to inject for `GraphBuilder` on next forms
// ==================================================================
import { NextFormFeaturesModule } from '../forms/features/next-form-features.module';
import { NextGeolocationSerivce } from '../services/next-geolocation.service';
import { TemplateModule } from './template/template.module';
import { NextValidationMessageBuilderService } from './validation/validation-message-builder.service';

@NgModule({
  declarations: [NextFormComponent],
  exports: [FormActionsComponent, NextFormComponent],
  imports: [FmntsDeclarativeFormsModule, FormActionsComponent],
  providers: [],
})
export class NextDeclarativeFormsUiModule {}

function provideForDeclarativeFormsModule(): Provider {
  return [
    {
      // Validation Message Builder
      provide: DECLARATIVE_FORMS_VALIDATION_MESSAGE_BUILDER_TOKEN,
      useClass: NextValidationMessageBuilderService,
    },
    // ==================================================================
    // Services to inject for `Validator` on next forms
    // ==================================================================
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: DateValidationBuilder,
      multi: true,
    },
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: PhoneValidationBuilder,
      multi: true,
    },
    {
      provide: DECLARATIVE_FORMS_VALIDATOR_TOKEN,
      useExisting: PaymentValidationService,
      multi: true,
    },
  ];
}

@NgModule({
  exports: [NextDeclarativeFormsUiModule],
  imports: [
    TemplateModule,
    DeclarativeFormsCommonModule,
    NextDeclarativeFormsUiModule,
  ],
  providers: [provideForDeclarativeFormsModule()],
})
export class DeclarativeFormsModule {}

@NgModule({
  exports: [NextDeclarativeFormsUiModule],
  imports: [DeclarativeFormsModule, NextFormFeaturesModule],
  providers: [
    provideDeclarativeFormsGeolocationFeature({
      geolocation: () => inject(NextGeolocationSerivce),
    }),
    {
      // Browser autocomplete for next forms should be disabled.
      provide: FMNTS_FORMS_OPTIONS,
      useValue: {
        autocomplete: false,
        forceAutocompleteOff: true,
      },
    },
  ],
})
export class NextDeclarativeFormsModule {}
